import React from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { Button } from 'reactstrap';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import renderField from '../../../shared/components/custom/Field';
import FormCard from '../../../shared/components/custom/FormCard';
import validate from './validateApi';
import t, { partial } from '../../../util/translation/translation';

const NewsAPIForm = ({ handleSubmit, apiAccess }) => {
  const s = partial('shared');
  return (
    <form onSubmit={handleSubmit} className="form settings-form">
      <div className="user-layout">
        <FormCard title={t('NewsForm.apiKey')}>
          <p className="user-form__hint">{t('NewsForm.apiKeyHint')}</p>
          <div className="form__form-group mb-0">
            <span className="form-header">{s('companyName')}</span>
            <Field
              name="entityName"
              component={renderField}
              placeholder={s('companyName')}
            />
          </div>
        </FormCard>
        <FormCard
          title={
            <>
              {t('NewsForm.companiesWithKey')}
              <span className="form-card__count">{apiAccess.length}</span>
            </>
          }
          bodyClassName="form-card__body--flush"
        >
          {apiAccess.length ? (
            <ul className="settings-side-list settings-side-list--plain">
              {apiAccess.map((access) => (
                <li key={access.id}>
                  <span>{access.entityName}</span>
                  <span className="settings-side-list__meta">
                    {(access.usage?.requestAmount ?? 0).toLocaleString()}{' '}
                    {s('usage').toLowerCase()}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="settings-side-list__empty">{s('noApiKeys')}</p>
          )}
        </FormCard>
      </div>
      <div className="messages-form__footer">
        <span />
        <div className="messages-form__secondary">
          <Link
            to="/news?tab=2"
            className="btn btn-outline-secondary btn-sm mb-0"
          >
            {s('close')}
          </Link>
          <Button type="submit" color="primary" size="sm" className="mb-0">
            {s('create')}
          </Button>
        </div>
      </div>
    </form>
  );
};

NewsAPIForm.defaultProps = {
  apiAccess: [],
};

const reduxF = reduxForm({
  form: 'news_api_form',
  validate,
});

export default withRouter(
  connect((state) => ({
    formValues: getFormValues('news_api_form')(state),
  }))(reduxF(NewsAPIForm))
);
